module.exports = __webpack_public_path__ + "img/666116f5-4690-4362-9a5c-f0cc01a30863.ed2fcd4e.png";